module.exports = __webpack_public_path__ + "img/768-5edbfc.png";